import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d0bbb6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = { class: "characterCount" }

import { PropType, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { CommunicationViewModel } from '@/model/ViewModel';
import MessageHeaders from '@/components/MessageHeaders.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'SMSPreview',
  props: {
    message: {
        type: Object as PropType<CommunicationViewModel>,
        required: true
    }
},
  setup(__props) {

const props = __props

const { t } = useI18n();




const headers = computed(() =>
{
    const result: any = {};

    result[t('header.fromName')] = props.message.SMS!.FromName;
    result[t('header.to')] = props.message.SMS!.To;

    return result;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MessageHeaders, { headers: _unref(headers) }, null, 8, ["headers"]),
    _createElementVNode("div", _hoisted_1, _toDisplayString(__props.message.SMS!.Body), 1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('characterCount', { count: __props.message.SMS!.Body.length })), 1)
  ], 64))
}
}

})